module.exports = __webpack_public_path__ + "public/media/tejjara.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/tejjara.png
// module id = ./images/partners/tejjara.png
// module chunks = 0